import { TraceableProcess, TrackingEvent } from '@services/analytics/model';
import { ReportableError } from './reportable-error';

export class UnhandledRenderingErrorRaisedEvent implements TrackingEvent {
  category = TraceableProcess.EXPERIMENTS;
  action = 'unhandled-rendering-error-raised';

  constructor(public readonly error: ReportableError) {}

  static of = (error: ReportableError): UnhandledRenderingErrorRaisedEvent => {
    return new UnhandledRenderingErrorRaisedEvent(error);
  };
}
